import {Validator} from 'vee-validate'
import {BasicSelect} from 'vue-search-select'
import ClientService from '../../../../services/clientmanagement.service';
import ServiceforCityandState from '../../../../../masterdata/services/masterdata.service';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'clientKYC',
  components: {
    BasicSelect,
    VueElementLoading,
    Multiselect,
    Treeselect
  },
  props: ['statelist','clientData'],
  data() {
    return {
      //for General Information Accordian
      companyname: '',
      companywebsite: '',
      address1: '',
      address2: '',
      state: null,
      citylist: [],
      city: null,
      selectedpincode: {
        "value": '',
        "text": ''
      },
      pincode: '',
      //for Client Spoc Details Accordian
      fname: '',
      lname: '',
      designation: '',
      email: '',
      mobileno: '',
      phoneno: '',
      extension: '',
      SPOCDetailsId : '',
      //for Legal Information Accordion
      companynamecheck: false,
      companyregistername: '',
      companyaddresscheck: false,
      raddress1: '',
      raddress2: '',
      rstate: null,
      selectedrstate: {
        "id": '',
        "label": ''
      },
      rcity: null,
      rcitylist : [],
      selectedrcity: {
        "id": '',
        "label": ''
      },
      selectedrpincode: {
        "value": '',
        "text": ''
      },
      rpincode: '',
      gstno: '',
      gstFilePath : '',
      regno: '',
      regnoFilePath : {},
      panno: '',
      pannoFilePath : {},
      tan: '',
      //for Bank information Accordian
      beneficaryname: '',
      bankname: '',
      bankbranch: '',
      ifsc: '',
      bankaccountno: '',
      bankCancelChequePath : {},
      useremail : '',
      clientSystemID : '',
      clientBusinessAccountId : '',
      OldClientMasterId : '',
      clientBusinessDetailID : '',
      clientShortName : '',
      clientAccountName : '',
      IsActive : '',
      isLoading : false,
      legelDocumentFlag :false,
      cancelCheqFlag : false,
      gstFileName : '',
      rNoFileName : '',
      panFileName : '',
      cancelCheqFileName : '',
      userrole : '',
      userid : '',
      disableAllFileds : false,
      bdLoading : '',
      bdList : [],
      bdids : null,
      kamLoading : '',
      kamList : [],
      kamids : null,
      rolename : '',
      username : '',
      expanded:false,
			accordianTab:{1:false, 2:false, 3:false, 4:false, 5:false, 6:false},
      approvesend : false,
      GSTData : [{
        "gststate" : null,
        "gstno" : '',
        "gstdocument" : {
          filename:'',
          filepath:''
        },
      }],
      gstdocument:[
        {
          filename:'',
          filepath:''
        }
      ]
    }
  },
  computed: {},
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.rolename = userdetail.rolename[0];
    this.username = userdetail.username;
    // this.userrole = parseInt(userdetail.userrole);
    this.userrole = userdetail.rolename[0];
    this.userid = parseInt(userdetail.userid);
    if(this.statelist.length==0){
      await this.getStateList();
    }

    this.isLoading = true;
    await this.getBDList();
    this.isLoading = false;

    if(this.clientData && this.clientData.ClientSystemID){
      this.isLoading = true;
      await Promise.all([
        this.getClientBDList(this.clientData.ClientSystemID,this.clientData.ClientBusinessAccountId),
        this.getClientAccountKYCDetails(this.clientData.ClientBusinessAccountId),
        this.getClientHirarchInfo(this.clientData.ClientBusinessAccountId)
      ]);
     this.isLoading = false;
    }

  },
  methods: {
    handleTab(tabid){
for (var key in this.accordianTab) {
  if(tabid = key){
    this.accordianTab[key] = false;
  }
  if(tabid = 1){
    this.accordianTab[2] = true;
  }
 }
},
handleTab1(tabid){
  for (var key in this.accordianTab) {
    if(tabid = key){
      this.accordianTab[key] = false;
    }
    if(tabid = 2){
      this.accordianTab[3] = true;
    }
  }
},
    handleTab2(tabid){
for (var key in this.accordianTab) {
  if(tabid = key){
    this.accordianTab[key] = false;
  }
  if(tabid = 3){
    this.accordianTab[4] = true;
  }
 }
},
handleTab3(tabid){
for (var key in this.accordianTab) {
  if(tabid = key){
    this.accordianTab[key] = false;
  }
  if(tabid = 4){
    this.accordianTab[5] = true;
  }
 }
},
    handleTab4(tabid){
for (var key in this.accordianTab) {
  if(tabid = key){
    this.accordianTab[key] = false;
  }
 }
},
    expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
      this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
    async getBDList(){
      try {
        let tempBDList = [];
        let tempKAMList = [];
        this.bdList = [];
        this.kamList = [];
        let result = await ClientService.getBDList();
        tempBDList = result.data.data;
        for (var i = 0; i < tempBDList.length; i++) {
          if(tempBDList[i].UserType=="BD"){
            this.bdList.push({
              'id': tempBDList[i].UserID,
              'label': tempBDList[i].Name,
              'email': tempBDList[i].EmailAddress,
              'contactno': tempBDList[i].ContactNo
            });
          }
          if(tempBDList[i].UserType=="KAM"){
            this.kamList.push({
              'id': tempBDList[i].UserID,
              'label': tempBDList[i].Name,
              'email': tempBDList[i].EmailAddress,
              'contactno': tempBDList[i].ContactNo
            })
          }
        }
      } catch (e) {
        this.isLoading = false;
        this.bdLoading = '';
        this.kamLoading = '';
      }
    },
    async getClientBDList(clientid, clientbusinessaccountid){
      try {
        let payload = {
          clientid : clientid,
          clientbusinessaccountid : clientbusinessaccountid
        }
        let result = await ClientService.getClientBDList(payload);
        let tempClientBDList = result.data.data;
        let tempArr = [];
        let tempArr1 = [];
        for (var i = 0; i < tempClientBDList.length; i++) {
          if(tempClientBDList[i].type=="BD"){
            tempArr.push({
              'id': tempClientBDList[i].bduserid,
              'label': tempClientBDList[i].bdusername,
              'email': tempClientBDList[i].bdemail,
              'contactno': tempClientBDList[i].contactno
            });
          }
          if(tempClientBDList[i].type=="KAM"){
            tempArr1.push({
              'id': tempClientBDList[i].bduserid,
              'label': tempClientBDList[i].bdusername,
              'email': tempClientBDList[i].bdemail,
              'contactno': tempClientBDList[i].contactno
            });
          }
        }
        this.bdids = tempArr;
        this.kamids = tempArr1;
      } catch (e) {
        this.isLoading = false;
        this.bdLoading = '';
        //return this.$alert('BD List User Not Found', "Client KYC", "error");
      }
    },
    //for General Information
    async getClientHirarchInfo(clientid){
      let payload = {
        clientid : clientid,
        roleID : this.userrole,
        userID : this.userid,
        objectType : 'client'
      }
     let result = await ClientService.getClientInfoExist(payload);
     if (result.data.data.data.length > 0) {
       this.disableAllFileds = true;
     }
     if (result.data.data.edit == true) {
       this.approvesend = true;
     }else {
       this.approvesend = false;
     }
   },
   async getClientAccountKYCDetails(clientid){
     try {
       let payload = {
         clientid : clientid
       }
       let result = await ClientService.getClientAccountKYCDetails(payload);
       if (result.data.code == 200 ) {
         let clientData = result.data.data.data[0];
         this.clientSystemID = clientData.ClientSystemID;
         this.clientBusinessAccountId = clientData.ClientBusinessAccountId;
         this.OldClientMasterId = clientData.OldClientMasterId;
         this.clientBusinessDetailID = clientData.ClientBusinessDetailID;
         this.clientShortName = clientData.ClientShortName;
         this.clientAccountName = clientData.AccountName;
         this.IsActive = (clientData.Status)?1:0;

         if (clientData.generalInfo) {
           if (clientData.generalInfo.ClientState != null) {
             for (var i = 0; i < this.statelist.length; i++) {
                if (this.statelist[i].label == clientData.generalInfo.ClientState) {
                  this.state = this.statelist[i].id
                  this.selectedstate = this.statelist[i];
                }
              }
            }
           if (clientData.generalInfo.ClientCity != null) {
            await this.getCityList(parseInt(this.state))
            for (var i = 0; i < this.citylist.length; i++) {
              if (this.citylist[i].label == clientData.generalInfo.ClientCity.toUpperCase()) {
                  this.city = this.citylist[i].id;
                  this.selectedcity = this.citylist[i];
                }
              }
            }
           if (clientData.generalInfo.ClientPinCode != null) {
            this.pincode = clientData.generalInfo.ClientPinCode
           }
           if (clientData.generalInfo.CompanyName != null) {
             this.companyname = clientData.generalInfo.CompanyName
           }
           if (clientData.generalInfo.CompanyWebsite != null) {
             this.companywebsite = clientData.generalInfo.CompanyWebsite
           }
           if (clientData.generalInfo.clientAddress != null) {
             let address = clientData.generalInfo.clientAddress.split("+")
               this.address1 = address[0];
               this.address2 = address[1];
            }
          }

          if (clientData.clientSPOCInfo) {
              if (clientData.clientSPOCInfo.Name != '') {
               let name = clientData.clientSPOCInfo.Name.split("+")
               this.fname = name[0];
               this.lname = name[1]
              }
              if (clientData.clientSPOCInfo.Email != '') {
               this.email = clientData.clientSPOCInfo.Email
              }
              if (clientData.clientSPOCInfo.designation != '') {
                this.designation = clientData.clientSPOCInfo.designation
              }
              if (clientData.clientSPOCInfo.ContactNo != '') {
                this.mobileno = clientData.clientSPOCInfo.ContactNo
              }

              if (clientData.clientSPOCInfo.phoneNumber != '') {
                this.phoneno = clientData.clientSPOCInfo.phoneNumber
              }

              if (clientData.clientSPOCInfo.extension != '') {
                this.extension = clientData.clientSPOCInfo.extension
              }

              if (clientData.clientSPOCInfo.SPOCDetailsId) {
                this.SPOCDetailsId = clientData.clientSPOCInfo.SPOCDetailsId;
              }
          }

          if (clientData.companyLegalInfo) {
            if (clientData.companyLegalInfo.companyRegisteredName) {
              this.companyregistername = clientData.companyLegalInfo.companyRegisteredName;
            }
            if (clientData.companyLegalInfo.companyBusinessAddress) {
              let address = clientData.companyLegalInfo.companyBusinessAddress.split('+');
              this.raddress1 = address[0];
              this.raddress2 = address[1];
            }
            if (clientData.companyLegalInfo.companyRegisteredStateID) {
              for (var i = 0; i < this.statelist.length; i++) {
                 if (this.statelist[i].label == clientData.companyLegalInfo.companyRegisteredStateID) {
                    this.rstate = this.statelist[i].id;
                    this.selectedrstate = this.statelist[i];
                 }
               }
               await this.getRCityList(parseInt(this.rstate))
               for (var i = 0; i < this.rcitylist.length; i++) {
                 if (this.rcitylist[i].label == clientData.companyLegalInfo.companyRegisteredCityID.toUpperCase()) {
                   this.rcity = this.rcitylist[i].id
                   this.selectedrcity = this.rcitylist[i];
                 }
               }
             }
            if (clientData.companyLegalInfo.companyRegisteredPinCode) {
              this.rpincode = clientData.companyLegalInfo.companyRegisteredPinCode;
            }

            let gstDataArr = [];
            if(clientData.companyLegalInfo.gstdetails.length > 0){
              let gstdata = clientData.companyLegalInfo.gstdetails;
              gstdata.forEach(function (item) {
                gstDataArr.push({
                    gststate: item.RegistrationState,
                    gstno: item.RegistrationNumber,
                    gstdocument: {
                      filepath:(item.FilePath)?item.FilePath:"",
                      filename:(item.FilePath)?item.FilePath.substring(item.FilePath.lastIndexOf('.')+1).toLowerCase():""
                    }
                  });
              });
              this.GSTData = gstDataArr;
            }

            if (clientData.companyLegalInfo.registrationNumber) {
              this.regno = clientData.companyLegalInfo.registrationNumber;
            }
            if (clientData.companyLegalInfo.registrationNumberFilePath) {
               this.regnoFilePath = clientData.companyLegalInfo.registrationNumberFilePath;
               if (this.regnoFilePath.filePath != undefined && this.regnoFilePath.filePath[0]!= null) {
                 this.rNoFileName = this.regnoFilePath.filePath[0].substring(this.regnoFilePath.filePath[0].lastIndexOf('.')+1).toLowerCase();
               }
            }
            if (clientData.companyLegalInfo.panNumber) {
              this.panno = clientData.companyLegalInfo.panNumber;
            }
            if (clientData.companyLegalInfo.panNumberFilePath) {
              this.pannoFilePath = clientData.companyLegalInfo.panNumberFilePath;
              if (this.pannoFilePath.filePath != undefined) {
                this.panFileName = this.pannoFilePath.filePath[0].substring(this.pannoFilePath.filePath[0].lastIndexOf('.')+1).toLowerCase();
              }
            }
            if (clientData.companyLegalInfo.tanNumber) {
              this.tan = clientData.companyLegalInfo.tanNumber;
            }
            if (this.raddress1 == this.address1 &&
              this.raddress2 == this.address2 && this.rstate == this.state &&
              this.rcity == this.city && this.rpincode == this.pincode &&
              this.rpincode != '' && this.rcity != null && this.rstate != null) {
               this.companyaddresscheck = true;
            }
            if (this.companyregistername == this.companyname && this.companyname != '') {
               this.companynamecheck = true;
            }
          }

          if (clientData.clientBankInfo) {
            if (clientData.clientBankInfo.beneficaryName) {
               this.beneficaryname = clientData.clientBankInfo.beneficaryName;
            }
            if (clientData.clientBankInfo.bankName) {
               this.bankname = clientData.clientBankInfo.bankName;
            }
            if (clientData.clientBankInfo.bankBranch) {
               this.bankbranch = clientData.clientBankInfo.bankBranch;
            }
            if (clientData.clientBankInfo.ClinetIFSCNumber) {
               this.ifsc = clientData.clientBankInfo.ClinetIFSCNumber;
            }
            if (clientData.clientBankInfo.bankAccountNumber) {
               this.bankaccountno = clientData.clientBankInfo.bankAccountNumber;
            }
            if (clientData.clientBankInfo.cancelledchequeFilePath.filePath) {
               this.bankCancelChequePath.filePath = clientData.clientBankInfo.cancelledchequeFilePath.filePath[0];
               this.bankCancelChequePath.uploadDocumetID = clientData.clientBankInfo.cancelledchequeFilePath.uploadDocumetID;
               if(clientData.clientBankInfo.cancelledchequeFilePath.filePath[0]){
                 this.cancelCheqFileName = clientData.clientBankInfo.cancelledchequeFilePath.filePath[0].substring(clientData.clientBankInfo.cancelledchequeFilePath.filePath[0].lastIndexOf('.')+1).toLowerCase();
               }
            }else {
              this.bankCancelChequePath = {};
            }
          }
       }
       this.isLoading = false;
     } catch (e) {
       this.isLoading = false;
       this.$alert(e.message,"Client KYC","error");
     }
   },
    fileview(index){
      var link = document.createElement('a');
      link.href = index;
      link.setAttribute('target','_blank');
      window.open(index, '_blank');
      link.remove();
      return true;
    },
    async getStateList() {
      let tempStateList = [];
      this.statelist = [];
      try {
        let result = await ServiceforCityandState.getStateList();
        tempStateList = result.data.data
        for (var i = 0; i < tempStateList.length; i++) {
          this.statelist.push({
            'id': tempStateList[i].stateid,
            'label': tempStateList[i].statename.toUpperCase()
          })
        }
      } catch (err) {
        this.statelist = [];
        this.$alert(err.message,this.state,"error");
      }
    },
    async getCityList(cityid) {
      let tempCityStateWiseList = [];
      this.citylist = []
      try {
        let inputPayload = {
          "stateId": [cityid]
        }
        let result = await ServiceforCityandState.getCityList(inputPayload)
        tempCityStateWiseList = result.data.data
        for (var i = 0; i < tempCityStateWiseList.length; i++) {
          this.citylist.push({
            'id': tempCityStateWiseList[i].cityid,
            'label': tempCityStateWiseList[i].cityname.toUpperCase()
          })
        }
      } catch (err) {
        this.citylist = [];
        //this.$alert(err.message,"Client KYC","error");
      }
    },
    selectState(selectedfltstate) {
      this.selectedstate = selectedfltstate;
      this.state = selectedfltstate.id;
      this.citylist = [];
      if (selectedfltstate.id != '' && selectedfltstate.id !=undefined) {
        this.city = null;
        this.selectedcity = {
          "id": '',
          "label": ''
        };
        this.pincode = '';
        this.getCityList(selectedfltstate.id);
      }
    },
    selectCity(selectedfltcity) {
      this.selectedcity = selectedfltcity;
      this.city = selectedfltcity.id;
      this.pincode = '';
    },
    //for Legal Information Accordion
    fillCompanyName() {
      if (this.companyname != '') {
        if (this.companynamecheck == true) {
          this.companyregistername = this.companyname;
        }else {
          this.companyregistername = '';
        }
      }else {
        this.companynamecheck = false;
        this.$alert("Please Enter First Company Business/Trade Name","Client KYC","error");
      }
    },
    fillCompanyAddress() {
      if (this.address1 != '' && this.state!= '' && this.city != null
        && this.pincode != '') {
        if (this.companyaddresscheck == true) {
          this.rcitylist = this.citylist;
          this.raddress1 = this.address1;
          this.raddress2 = this.address2;
          this.selectedrstate = this.selectedstate;
          this.rstate = this.state;
          this.selectedrcity = this.selectedcity;
          this.rcity = this.city;
          this.rpincode = this.pincode;
        }else {
          this.raddress1 = '';
          this.raddress2 = '';
          this.selectedrstate = {
            "value": '',
            "text": ''
          };
          this.rstate = null;
          this.selectedrcity = {
            "value": '',
            "text": ''
          };
          this.rcity = null;
          this.rpincode = '';
        }
      }else {
        this.companyaddresscheck = false;
        this.$alert("Please Enter First Company Business Address","Client KYC","error");
      }
    },
    selectRState(selectedfltstate) {
      this.selectedrstate = selectedfltstate
      this.rstate = selectedfltstate.id
      this.citylist = [];
      if (selectedfltstate.id != '') {
        this.selectedrcity = {
          "value": '',
          "text": ''
        };
        this.rcity = null;
        this.rpincode = '';
        this.getRCityList(selectedfltstate.id);
      }
    },
    async getRCityList(cityid) {
      let tempCityStateWiseList = [];
      this.rcitylist = []
      try {
        let inputPayload = {
          "stateId": [cityid]
        }
        let result = await ServiceforCityandState.getCityList(inputPayload)
        tempCityStateWiseList = result.data.data
        for (var i = 0; i < tempCityStateWiseList.length; i++) {
          this.rcitylist.push({
            'id': tempCityStateWiseList[i].cityid,
            'label': tempCityStateWiseList[i].cityname.toUpperCase()
          })
        }
      } catch (err) {
        this.rcitylist = [];
        this.$alert(err.message,"Client KYC","error");
      }
    },
    selectRCity(selectedfltcity) {
      this.selectedrcity = selectedfltcity;
      this.rcity = selectedfltcity.id;
      this.rpincode = '';
    },
    async onFileChangedForGST(event){
      let filepath = "gstDoc";
      this.legelDocumentFlag = true;
      this.uploadDoc(filepath,event);
    },
    async onFileChangedForRegistration(event){
      let filepath = "registrationDoc";
      this.legelDocumentFlag = true;
      this.uploadDoc(filepath,event);
    },
    async onFileChangedForPAN(event){
      let filepath = "panDoc";
      this.legelDocumentFlag = true;
      this.uploadDoc(filepath,event);
    },
    uploadCancelChecque(event) {
      this.cancelCheqFlag = true;
      let filepath = "cancelledchequeDoc";
      this.uploadDoc(filepath,event);
    },
    async uploadGSTDocument(event,documentid){
      this.legelDocumentFlag = true;
      let filepath = "gstDoc";
      let uploadFile = event.target.files[0];
      if(uploadFile.size > 20971520){
        this.legelDocumentFlag = false;
        return this.$alert(`Please Upload Document Less Than 20MB.`,"Client KYC","error");
      }
      if (uploadFile.type == "image/jpeg" || uploadFile.type == "image/jpg" ||
      uploadFile.type == "application/pdf" || uploadFile.type == "image/png" ||
      uploadFile.type == "application/msword" ||
      uploadFile.type == "application/wps-office.docx" ||
      uploadFile.type == "application/wps-office.doc" ||
      uploadFile.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      uploadFile.type == "")
      {
        let formData = new FormData();
        formData.append("file", uploadFile);
        formData.append(filepath, true);
        formData.append("companyShortName", this.clientShortName);
        formData.append("fileName", uploadFile.name);
        let result = await ClientService.uploadDocment(formData);
        this.legelDocumentFlag = false;
        if (result.data.errorCode == 0) {
          let gstFilePath = result.data.data;
          let gstFileName = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
          this.GSTData[documentid].gstdocument = {
            filename: gstFileName,
            filepath: gstFilePath
          }
          this.$alert(`GST Document Upload successfully.`,"Client KYC","success");
        } else {
          event.target.value = '';
          this.$alert("Document Upload Failed.","GST Document","error");
        }
      }else {
        event.target.value = '';
        this.legelDocumentFlag = false;
        this.$alert("please upload only Allowed file format","GST Document","error");
        return true;
      }
    },
    async uploadDoc(filepath,event) {
      let uploadFile = event.target.files[0];
      if(uploadFile.size > 20971520){
        this.legelDocumentFlag = false;
        this.cancelCheqFlag = false;
        return this.$alert(`Please Upload Document Less Than 20MB.`,"Client KYC","error");
      }
      if (uploadFile.type == "image/jpeg" ||
      uploadFile.type == "image/jpg" ||
      uploadFile.type == "application/pdf" ||
      uploadFile.type == "image/png" ||
      uploadFile.type == "application/msword" ||
      uploadFile.type == "application/wps-office.docx" ||
      uploadFile.type == "application/wps-office.doc" ||
      uploadFile.type == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      uploadFile.type == "")
      {
        let formData = new FormData();
        /*Add the form data we need to submit*/
        formData.append("file", uploadFile);
        formData.append(filepath, true);
        formData.append("companyShortName", this.clientShortName);
        formData.append("fileName", uploadFile.name);

        let result = await ClientService.uploadDocment(formData)
        if (result.data.errorCode == 0) {
          //this.$alertify.success("Document Upload successfully");
          let alertMessage = '';
          if (filepath == "registrationDoc") {
            alertMessage = "Registration Document"
            this.regnoFilePath = {};
            this.regnoFilePath.filePath = result.data.data;
            this.rNoFileName = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
            this.legelDocumentFlag = false;
          }
          if (filepath == "panDoc") {
            alertMessage = "PAN Document"
            this.pannoFilePath = {};
            this.pannoFilePath.filePath = result.data.data;
            this.panFileName = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
            this.legelDocumentFlag = false;
          }
          if (filepath == "cancelledchequeDoc") {
            alertMessage = "Cancelled Cheque Document"
            this.bankCancelChequePath = {};
            this.bankCancelChequePath.filePath = result.data.data;
            this.cancelCheqFileName = uploadFile.name.substring(uploadFile.name.lastIndexOf('.')+1).toLowerCase();
            this.cancelCheqFlag = false;
          }
          this.$alert(`${alertMessage} Upload successfully.`,"Client KYC","success");
        } else {
          event.target.value = '';
          this.legelDocumentFlag = false;
          this.cancelCheqFlag = false;
          this.$alert("Document Upload Failed.","Client KYC","error");
        }
      }else {
        event.target.value = '';
        this.legelDocumentFlag = false;
        this.cancelCheqFlag = false;
        this.$alert("please upload only Allowed file format","Client KYC","error");
       return true;
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    AvoidSpace: function(event) {
      var k = event ? event.which : window.event.keyCode;
      if (k === 32 && !this.ifsc.length) {
        event.preventDefault();
      }
      else {
        return true;
      }
    },
    AvoidSpacebeneficary: function(event) {
      var k = event ? event.which : window.event.keyCode;
      if (k === 32 && !this.beneficaryname.length) {
        event.preventDefault();
      }
      else {
        return true;
      }
    },
    AvoidSpacebankname: function(event) {
      var k = event ? event.which : window.event.keyCode;
      if (k === 32 && !this.bankname.length) {
        event.preventDefault();
      }
      else {
        return true;
      }
    },
    AvoidSpacebankbranch: function(event) {
      var k = event ? event.which : window.event.keyCode;
      if (k === 32 && !this.bankbranch.length) {
        event.preventDefault();
      }
      else {
        return true;
      }
    },
    AvoidSpaceGeneralInfo(){
      var k = event ? event.which : window.event.keyCode;
      if (k === 32 && !this.companyname.length) {
        event.preventDefault();
      }
      else {
        return true;
      }
    },
    AvoidSpaceSPOCInfo(){
      var k = event ? event.which : window.event.keyCode;
      if ((k === 32 && !this.fname.length) || (k === 32 && !this.lname.length)
       || (k === 32 && !this.designation.length) )  {
        event.preventDefault();
      }
      else {
        return true;
      }
    },
    clear(){
      this.gstFileName = '';
      this.rNoFileName = '';
      this.panFileName = '';
      this.cancelCheqFileName = '';
    },
    async sendForApprove(){
       let payload = {
         clientid : this.clientData.ClientSystemID,
         clientbusinessaccountid : this.clientData.ClientBusinessAccountId
       }
       this.isLoading = true;
       let resultclientInfo = await ClientService.getclientinfo(payload);
       this.isLoading = false;
       if (resultclientInfo.data.data.clientotherinfo == 1 && resultclientInfo.data.data.clientkyc == 1 && resultclientInfo.data.data.contracts == 1) {
         this.$confirm(`Do you want to send ${this.clientData.ClientShortName} for approval ?`,'Client Other Information','question').then(async (result) => {
           if (result) {
             let payload ={
               objectType : 'client',
               clientID : this.clientData.ClientBusinessAccountId,
               clientShortName : this.clientData.ClientShortName,
               createdby : this.useremail,
               roleID : this.userrole,
               userID : this.userid,
               rolename : this.rolename,
               username : this.username
             }
             this.isLoading = true;
             let approvalResult =  await ClientService.sendForApproveInKYC(payload)
             this.isLoading = false;
             this.$alert(`${approvalResult.data.message}`,"Client Other Information","success");
             this.$emit("goBackToParent");
           }
         }).catch(e =>{
           this.isLoading = false;
           this.$alert('Client Approve Request Cancel',"Client Other Information","error");
         });
       }else {
         this.$alert('Please Enter All Mandatory Field Of Client KYC, Other Information & Contract',"Client Approval","error");
       }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    addNewGST(index) {
      this.GSTData.push({
          gststate:null,
          gstno:'',
          gstdocument: {
            filename:'',
            filepath:''
          }
        });
      this.gstdocument[index+1]={
        'filename':'',
        'filepath': ''
      };
    },
    deleteGST(index) {
      this.$confirm("Remove selected GST Row.",'','question').then(()=>{
        this.GSTData.splice(index, 1);
        this.gstdocument.splice(index, 1);
      });
    },
    setname(id, name){
      return name+id;
    },
    isIntegerOnlty: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
    saveGeneralInformation(){
      this.$validator.validateAll("generalinformationform").then((result) => {
        if(result){
          this.saveClientInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveSPOCDetails(){
      this.$validator.validateAll("spocdetailsform").then((result) => {
        if(result){
          this.saveClientInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveBDDetails(){
      this.$validator.validateAll("bddetailsform").then((result) => {
        if(result){
          this.saveClientInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveLegalInformations(){
      this.$validator.validateAll("legalinformationform").then((result) => {
        if(result){
          this.saveClientInfo('save');
        }
      }).catch(() => {
        console.log('errors exist');
        return false;
      });
    },
    saveBankInformations(){
      this.saveClientInfo('save');
    },
    saveClientKYCDetails(){
      if(this.expanded){
        this.saveAndNext('save');
      }else{
        let selectedflag = 0;
        for (var key in this.accordianTab) {
          if(this.accordianTab[key]==true){
            if(key==1){
              selectedflag = 1;
              this.saveGeneralInformation();
            }else if(key==2){
              selectedflag = 1;
              this.saveSPOCDetails();
            }else if(key==3){
              selectedflag = 1;
              this.saveBDDetails();
            }else if(key==4){
              selectedflag = 1;
              this.saveLegalInformations();
            }else if(key==5){
              selectedflag = 1;
              this.saveBankInformations();
            }
          }
        }
        if(selectedflag==0){
          this.saveAndNext('save');
        }
      }
    },
    async saveClientInfo(actiontype) {
      if (this.clientSystemID =='' || this.clientBusinessAccountId == '' || this.clientBusinessDetailID == '') {
        this.$alert("Please Enter Client Short Name","Client KYC","error");
        return true
      }

      this.isLoading = true;
      var inputPayload = {};
      inputPayload.clientSystemID = this.clientSystemID;
      inputPayload.clientBusinessAccountId = this.clientBusinessAccountId;
      inputPayload.OldClientMasterId = this.OldClientMasterId;
      inputPayload.clientBusinessDetailID = this.clientBusinessDetailID;
      inputPayload.clientShortName = this.clientShortName;
      inputPayload.clientAccountName = this.clientAccountName;
      inputPayload.CreatedBy = this.useremail;
      inputPayload.IsActive = this.IsActive;

      if(this.companyname!="" && this.companywebsite!="" && this.address1!="" && this.state!="" && this.city!="" && this.pincode!=""){
        inputPayload.companyBasicInfo = {};
        inputPayload.companyBasicInfo.companyName = this.companyname;
        inputPayload.companyBasicInfo.companyWebsite = this.companywebsite;
        if(this.address2){
          inputPayload.companyBasicInfo.clientAddress = this.address1 + '+' + this.address2;
        }else{
          inputPayload.companyBasicInfo.clientAddress = this.address1;
        }

        inputPayload.companyBasicInfo.clientCityID = this.selectedcity.label;
        inputPayload.companyBasicInfo.clientStateID = this.selectedstate.label;
        inputPayload.companyBasicInfo.clientPinCode = this.pincode;
      }

      if(this.fname!="" && this.email!="" && this.mobileNumber!=""){
        inputPayload.clientSPOCInfo = {};
        inputPayload.clientSPOCInfo.name = this.fname +'+' + this.lname;
        inputPayload.clientSPOCInfo.email = this.email;
        inputPayload.clientSPOCInfo.mobileNumber = this.mobileno;
        if (this.phoneno) {
          inputPayload.clientSPOCInfo.phoneNumber = this.phoneno;
        }
        if (this.extension) {
          inputPayload.clientSPOCInfo.extension = this.extension;
        }
        if (this.designation) {
          inputPayload.clientSPOCInfo.designation = this.designation;
        }
        if (inputPayload.SPOCDetailsId) {
          payload.clientSPOCInfo.clientSPOCDetailsId = this.SPOCDetailsId;
        }
      }

      if(this.companyregistername!="" && this.raddress1!="" && this.rstate!="" && this.rcity!="" && this.rpincode!=""
        && this.GSTData.length > 0
        && this.panno!="" && this.pannoFilePath.filePath!=""
      ){
        inputPayload.companyLegalInfo = {};
        inputPayload.companyLegalInfo.companyRegisteredName = this.companyregistername
        if(this.raddress2){
          inputPayload.companyLegalInfo.companyBusinessAddress = this.raddress1 + "+" + this.raddress2;
        }else{
          inputPayload.companyLegalInfo.companyBusinessAddress = this.raddress1;
        }

        inputPayload.companyLegalInfo.companyRegisteredCityID = this.selectedrcity.label;
        inputPayload.companyLegalInfo.companyRegisteredStateID = this.selectedrstate.label;
        inputPayload.companyLegalInfo.companyRegisteredPinCode = this.rpincode;
        inputPayload.companyLegalInfo.gstdetails = this.GSTData;

        inputPayload.companyLegalInfo.registrationNumber = this.regno;
        let rFilePath = {};
        if ( this.regnoFilePath.uploadDocumetID ) {
          rFilePath.uploadDocumetID = this.regnoFilePath.uploadDocumetID;
          rFilePath.filePath = this.regnoFilePath.filePath[0];
        }else {
          rFilePath.filePath = this.regnoFilePath.filePath;
        }
        if(rFilePath.filePath !=null){
          inputPayload.companyLegalInfo.registrationNumberFilePath = rFilePath;
        }
        inputPayload.companyLegalInfo.panNumber = this.panno;
        let pFilePath = {};
        if ( this.pannoFilePath.uploadDocumetID) {
          pFilePath.uploadDocumetID = this.pannoFilePath.uploadDocumetID;
          pFilePath.filePath = this.pannoFilePath.filePath[0];
        }else {
          pFilePath.filePath = this.pannoFilePath.filePath;
        }
        inputPayload.companyLegalInfo.panNumberFilePath = pFilePath;
        inputPayload.companyLegalInfo.tanNumber = this.tan;
      }

      if(this.bdids!=null){
        inputPayload.clientBDInfo = {};
        inputPayload.clientBDInfo.bdusers = this.bdids;
      }
      if(this.kamids!=null){
        inputPayload.clientKAMInfo = {};
        inputPayload.clientKAMInfo.kamusers = this.kamids;
      }

      inputPayload.clientBankInfo = {};
      inputPayload.clientBankInfo.bankAccountNumber = this.bankaccountno.toString();
      inputPayload.clientBankInfo.bankName = this.bankname.trim();
      inputPayload.clientBankInfo.bankBranch = this.bankbranch.trim();
      inputPayload.clientBankInfo.clinetIFSCNumber = this.ifsc.trim();
      inputPayload.clientBankInfo.beneficaryName = this.beneficaryname.trim();
      if(this.bankCancelChequePath.filePath){
        inputPayload.clientBankInfo.cancelledchequeFilePath = this.bankCancelChequePath;
      }

      let result = await ClientService.addclientkycInfo(inputPayload);
      this.isLoading = false;
      if (result.data.code == 200) {
        this.$alert(`Record saved successfully.`,this.clientShortName,"success");
        if(actiontype=='saveandnext'){
          console.log("ddd", actiontype);
          this.$emit(`goBackToParent1`);
        }
      }else {
        this.$alert(result.data.message,this.clientShortName,"error");
      }
    },
    async saveAndNext(actiontype){
      let generalinformationform =  await this.$validator.validateAll("generalinformationform").then((result) => { return result});
      let spocdetailsform =  await this.$validator.validateAll("spocdetailsform").then((result) => { return result});
      let bddetailsform =  await this.$validator.validateAll("bddetailsform").then((result) => { return result});
      let legalinformationform =  await this.$validator.validateAll("legalinformationform").then((result) => { return result});

      if(!generalinformationform){ this.accordianTab[1] = true; }else{ this.accordianTab[1] = false; }
      if(!spocdetailsform){ this.accordianTab[2] = true; }else{ this.accordianTab[2] = false; }
      if(!bddetailsform){ this.accordianTab[3] = true; }else{ this.accordianTab[3] = false; }
      if(!legalinformationform){ this.accordianTab[4] = true; }else{ this.accordianTab[4] = false; }
      if(generalinformationform && spocdetailsform && bddetailsform && legalinformationform){
        this.saveClientInfo(actiontype);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/addclient/clientKYC/clientKYC.component.js